import CardlessAddressHistoryQuestion from '../components/Questions/CardlessAddressHistoryQuestion'
import ContactNumberQuestion from '../components/Questions/ContactNumberQuestion'
import EmailAddressQuestion from '../components/Questions/EmailAddressQuestion'
import CardlessEmploymentHistoryQuestion from '../components/Questions/CardlessEmploymentHistoryQuestion'
import { LoanAmountQuestion } from '../components/Questions/LoanAmountQuestion'
import MaritalStatusQuestion from '../components/Questions/MaritalStatusQuestion'
import { MonthlyIncomeQuestion } from '../components/Questions/MonthlyIncomeQuestion'
import PersonalDetailsQuestion from '../components/Questions/PersonalDetailsQuestion'
import TitleQuestion from '../components/Questions/TitleQuestion'
import VehicleTypeQuestion from '../components/Questions/VehicleTypeQuestion'
import DateOfBirth from '../components/Questions/DateOfBirth'
import { GroupedQuestionsForReorderingCase } from '../components/Questions/GroupedQuestionsForReorderingCase'

import QuestionComponentProps from './question-component-props'
import QuestionKey from './question-key'
import ContactInfoQuestion from '../components/Questions/ContactInfoQuestion'
import DoubleColumnRadioDrivingLicenceQuestion from '../components/Questions/DrivingLicenceQuestion/DoubleColumnRadioDrivingLicenceQuestion'
import RequiredDetails from '../components/ApplicationForm/RequiredDetails/RequiredDetailsFields'

const QuestionList: Record<QuestionKey, (props: QuestionComponentProps) => JSX.Element> = {
  vehicleType: VehicleTypeQuestion,
  loanAmount: LoanAmountQuestion,
  monthlyIncome: MonthlyIncomeQuestion,
  drivingLicence: DoubleColumnRadioDrivingLicenceQuestion,
  title: TitleQuestion,
  personalDetails: PersonalDetailsQuestion,
  contactNumber: ContactNumberQuestion,
  emailAddress: EmailAddressQuestion,
  maritalStatus: MaritalStatusQuestion,
  employmentHistory: CardlessEmploymentHistoryQuestion,
  addressHistory: CardlessAddressHistoryQuestion,
  groupedQuestionsForReorderingCase: GroupedQuestionsForReorderingCase,
  dateOfBirth: DateOfBirth,
  contactInfo: ContactInfoQuestion,
  requiredDetails: RequiredDetails
}

export default QuestionList
